module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }, [_c('h1', {
    staticClass: "ch_title_"
  }, [_vm._v("Contents")])]), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/005_Foreword"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/006_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/006_Introduction#sub0_1"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("1.")]), _vm._v(" Method")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/006_Introduction#sub0_2"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("2.")]), _vm._v(" An Overview of Battle Formations")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/006_Introduction#sub0_3"
    }
  }, [_vm._v("Note")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 1")]), _vm._v(" The Fundamentals of a Formation")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#sub1_1"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("1.")]), _vm._v(" Introduction")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#sub1_2"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("2.")]), _vm._v(" Heavy Infantry – Organisation")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#sub1_3"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("3.")]), _vm._v(" Heavy Infantry – Manoeuvres")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#sub1_4"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("4.")]), _vm._v(" Cavalry")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#sub1_5"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("5.")]), _vm._v(" Skirmisher Infantry")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#sub1_6"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("6.")]), _vm._v(" Peltasts")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#sub1_7"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("7.")]), _vm._v(" Elephants")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#sub1_8"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("8.")]), _vm._v(" Chariots")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#sub1_9"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1_"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 2")]), _vm._v(" The Hoplite Phalanx")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#sub2_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("1.")]), _vm._v(" The Battle of Thermopylae, 480 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#sub2_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("2.")]), _vm._v(" The Origins of the Hoplite Phalanx")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#sub2_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("3.")]), _vm._v(" The Hoplite’s Panoply")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#sub2_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("4.")]), _vm._v(" The Hoplite")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#sub2_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("5.")]), _vm._v(" The Structure of the Phalanx")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#sub2_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("6.")]), _vm._v(" Deploying the Phalanx for Battle")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#sub2_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("7.")]), _vm._v(" The Phalanx in Combat")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#sub2_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("8.")]), _vm._v(" Conclusion: the Effectiveness of the Hoplite Phalanx")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#sub2_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _c('h2', {
    staticClass: "toc1_"
  }, [_c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 3")]), _vm._v(" The Macedonian Phalanx")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#sub3_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("1.")]), _vm._v(" The Battle of Sellasia, 222 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#sub3_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("2.")]), _vm._v(" The Origins of the Macedonian Phalanx")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#sub3_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("3.")]), _vm._v(" The Phalangite’s Panoply")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#sub3_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("4.")]), _vm._v(" The Phalangite")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#sub3_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("5.")]), _vm._v(" The Structure of the Pike Phalanx")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#sub3_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("6.")]), _vm._v(" The Structure of the Macedonian Phalanx of Alexander")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#sub3_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("7.")]), _vm._v(" Deploying the Phalanx for Battle")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#sub3_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("8.")]), _vm._v(" The Phalanx in Battle Formation")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#sub3_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("9.")]), _vm._v(" The Push of Pikes")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#sub3_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("10.")]), _vm._v(" Conclusion: the Effectiveness of the Pike Phalanx")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#sub3_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1_"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 4")]), _vm._v(" The Triplex Acies")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#sub4_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("1.")]), _vm._v(" The Battle of Vesuvius, 340 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#sub4_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("2.")]), _vm._v(" The Development of the Triplex Acies")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#sub4_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("3.")]), _vm._v(" The Roman Soldier’s Panoply")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#sub4_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("4.")]), _vm._v(" The Roman Soldier")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#sub4_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("5.")]), _vm._v(" Fighting Techniques")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#sub4_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("6.")]), _vm._v(" The Legion on the March")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#sub4_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("7.")]), _vm._v(" Line Relief")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#sub4_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang1"
  }, [_vm._v("8.")]), _vm._v(" Conclusion: the Effectiveness of the Triplex Acies")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#sub4_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1_"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 5")]), _vm._v(" The Golden Age of Heavy Infantry")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5#sub5_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0